export function messageTimeSource(msg) {
  return msg?.timestamp || msg?.created_at || null;
}

export function formatChatDateLabel(ts, now = new Date()) {
  const d = new Date(ts);
  if (!ts || Number.isNaN(d.getTime())) return 'Today';
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  const day = new Date(d);
  day.setHours(0, 0, 0, 0);
  const diff = Math.round((start - day) / 86400000);
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Yesterday';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${d.getFullYear()}`;
}
